const text = (value) => String(value ?? '').trim();
const season = (value) => {
  const normalized = text(value);
  if (!normalized) throw new Error('raid_control_season_required');
  return normalized;
};

export function raidControlMessageArgs({ seasonId, body, mentionedUserIds = [], nikkeRefs = [], replyToId = null } = {}) {
  return {
    p_season_id: season(seasonId),
    p_body: text(body),
    p_mentioned_user_ids: [...new Set(mentionedUserIds.filter(Boolean))].slice(0, 10),
    p_nikke_refs: nikkeRefs.slice(0, 5),
    p_reply_to_id: replyToId || null,
  };
}

export function raidControlPracticeArgs({ seasonId, targetMemberOpenid, bossNo, phaseNo, damageEok, body = '', nikkeRefs = [] } = {}) {
  return {
    p_season_id: season(seasonId),
    p_target_member_openid: text(targetMemberOpenid),
    p_boss_no: Number(bossNo),
    p_phase_no: Number(phaseNo),
    p_damage_eok: Number(damageEok),
    p_body: text(body),
    p_nikke_refs: nikkeRefs.slice(0, 5),
  };
}

export function raidControlOrderArgs({ seasonId, targetMemberOpenid, bossNo, phaseNo, practiceRecordId = null, note = '' } = {}) {
  return {
    p_season_id: season(seasonId),
    p_target_member_openid: text(targetMemberOpenid),
    p_boss_no: Number(bossNo),
    p_phase_no: Number(phaseNo),
    p_practice_record_id: practiceRecordId || null,
    p_note: text(note),
  };
}

export function raidControlCustomOrderArgs({ seasonId, targetMemberOpenid, bossNo, phaseNo, title, expectedDamageEok, deck, note = '' } = {}) {
  return {
    p_season_id: season(seasonId),
    p_target_member_openid: text(targetMemberOpenid),
    p_boss_no: Number(bossNo),
    p_phase_no: Number(phaseNo),
    p_title: text(title),
    p_expected_damage_eok: Number(expectedDamageEok),
    p_deck: (Array.isArray(deck) ? deck : []).slice(0, 5),
    p_note: text(note),
  };
}
